<template>
 <div class="search">
  <div class="search__input">
   <input
     v-model="userInput"
     @keyup.enter="search()"
     :placeholder="I18n.t('auctions_catalogs.artworks_search_placeholder')"
    >
    <a href="#" class="search__clear-input">
      <span class="icon-close-big"
        v-if="userInput"
        @click="clearSearch"
      />
    </a>
  </div>
  <div class="search__actions">
    <span class="icon icon-auction"></span>
    <button
      type="button"
      class="btn-link search__btn-dropdown d-flex d-md-block"
    >
      {{ I18n.t("auctions_catalogs.artworks") }}
      <span class="icon icon-arrow-bottom"></span>
    </button>
    <button
      type="submit"
      class="btn-oval btn-oval--orange"
      @click="search()"
    >
    <a>
      <span class="icon icon-search"></span>
    </a>
    </button>
   </div>
</div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'ArtworkSearch',
    data() {
      return {
        userInput: this.$route.query.q || '',
      };
    },
    methods: {
      ...mapActions(['getArtworks']),
      fetchArtworks() {
        this.getArtworks({ search: this.searchParams });
      },
      search() {
        this.$router.push({ name: 'finishedAuctionsCatalog', query: { q: this.userInput } });
      },
      clearSearch() {
        this.userInput = '';
        this.$router.push({ name: 'finishedAuctionsCatalog' });
      },
    },
    watch: {
      searchParams() {
        this.fetchArtworks();
      },
    },
    computed: {
      searchParams() {
        return this.$route.query.q || '';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/search.vue?0bfbc894